module.exports = __webpack_public_path__ + "static/media/apnl_logo.d47f2843.png";